define('bindingHandlers/tooltip',[
    'jquery',
    'lib/lodash4',
    'lib/knockout',
    'util/externalInclude',
    'util/bindingHandlerUtils'
], function ($, _, ko, include, bindingHandlerUtils) {
    'use strict';

    //Constants declaration
    var EVENT_NAMESPACE         = ".tooltip-event";
    var LSTRING                 = "lString";
    var SHOW_DELAY              =  200; // ms
    var TOOLTIP_CONTAINER_CLASS = 'tooltip';
    var TOOLTIP_INNER_CLASS     = 'tooltip-inner';
    var TOOLTIP_INDICATOR_CLASS = 'tooltip-indicator';
    var TT_CONTAINER_NAME       = 'tooltip-container-binding';
    var SETTIMEOUT_BINDING_NAME = 'tooltip-settimeout-binding';
    var SHOW_CLASS              = 'tooltip-is-open';
    var COMPONENT_SUFFIX        = '-component';

    var TOOLTIP_ARROW_UP        = 'tooltip-arrow-up';
    var TOOLTIP_ARROW_DOWN      = 'tooltip-arrow-down';

    var TOOLTIP_TAIL_CLASS      = 'tooltip-arrow';
    var TOOLTIP_TAIL_RIGHT_POS  = 'tooltip-tail-right';
    var TOOLTIP_TAIL_LEFT_POS   = 'tooltip-tail-left';

    var TOOLTIP_HEADER          = 'tooltip-header';
    var TOOLTIP_CLOSE_BUTTON    = 'tooltip-close-button';
    var SELF_DISMISS_DEFAULT    = true;   //Default behavior for tooltip: true will self-dismiss tooltip by default;
    var IGNORE_CLICK            = false;  //Default behavior for tooltip: open/close tooltip on click;
    var DISPLAY_ON_TRUNCATE_ONLY_DEFAULT = false;  //disables rendering of tooltip unless associated content is truncated (NOTE:Must use block element for this option to work correctly)

    //Variable declaration
    var tooltip_counter         = 0;
    /**
     * Hides the tooltip container
     * @param tooltipIndicator
     */
    var hideTooltip = function (tooltipIndicator) {
        var tooltipContainer = getTooltipContainer(tooltipIndicator);
        if (tooltipContainer) {
            $(tooltipContainer).removeClass(SHOW_CLASS);
        }
    };

    /**
     * Shows the tooltip container
     * @param tooltipIndicator
     */
    var showTooltip = function (tooltipIndicator) {
        var tooltipContainer = getTooltipContainer(tooltipIndicator);
        if (tooltipContainer) {
            $(tooltipContainer).addClass(SHOW_CLASS);
            return tooltipContainer;
        }
    };

    /**
     * Handler for closing a tooltip. It verifies conditions to close the tooltip when event is thrown.
     * If the click event is thrown on a node inside of the tooltip container - the tooltip will not close.
     * @param event - click event
     */
    var HandleCloseTooltipFromDocument= function (event) {
        var target = event.target;
        var tooltipContainer = (event.data && event.data.tooltipContainer) ? event.data.tooltipContainer : null;
        var $closeBtn = $("." + TOOLTIP_CLOSE_BUTTON, tooltipContainer);

        var eventFromOutsideOfTooltipContainer = (tooltipContainer) ? !$.contains(tooltipContainer, target) : true;
        var eventIsFromCloseButton = ($closeBtn.length > 0) ?  $.contains($closeBtn[0], target) : false;
        if (eventFromOutsideOfTooltipContainer || eventIsFromCloseButton) {
            if (eventIsFromCloseButton) {
                event.preventDefault();
            }
            closeTooltip(event.data.tooltipIndicator);
        }
    };

    /***
     * Returns the tooltip (tooltip container)
     * @param tooltipIndicator
     * @returns node
     */
    var getTooltipContainer = function (tooltipIndicator) {
        return ko.utils.domData.get(tooltipIndicator, TT_CONTAINER_NAME);
    };

    /**
     * Calls openTooltip with a delay
     * @param e - Mouseover
     */
    var delayOpenTooltip = function (e) {
        var tooltipIndicator = e.currentTarget;
        clearTooltipOpenTimeout(tooltipIndicator);
        var showDelayHandle = setTimeout(function () { openTooltip(tooltipIndicator, e.data); }, SHOW_DELAY);
        ko.utils.domData.set(tooltipIndicator, SETTIMEOUT_BINDING_NAME, showDelayHandle);
        var options = { showSetTimeOutHandle: showDelayHandle };
        $(tooltipIndicator).one('mouseleave' + EVENT_NAMESPACE, options, cancelTimeOut);
    };

    var clearTooltipOpenTimeout = function (tooltipIndicator) {
        var showDelayHandle = ko.utils.domData.get(tooltipIndicator, SETTIMEOUT_BINDING_NAME);
        clearTimeout(showDelayHandle);
    };

    /***
     * Cancels the openTooltip invocation
     * @param e
     */
    var cancelTimeOut = function (e) {
        var showDelayHandle = e.data.showSetTimeOutHandle;
        clearTimeout(showDelayHandle);
    };

    /**
     * Verifies if the tooltip is currently opened or closed
     * @param tooltipIndicator
     * @returns {boolean}
     */
    var isTooltipOpen = function (tooltipIndicator) {
        var tooltipContainer = getTooltipContainer(tooltipIndicator);
        return tooltipContainer && $(tooltipContainer).hasClass(SHOW_CLASS);
    };

    /**
     * Handles what action to take when the tooltip indicator is clicked on
     * If the tooltip is open then close it
     * If the tooltip is closed then open it.
     * @param event
     */
    var handleClickOnTTIndicator = function (event) {
        var tooltipIndicator = event.currentTarget;
        openTooltip(tooltipIndicator, event.data);
    };

    /**
     * Closes other tooltips except for tooltipIndicator
     * @param tooltipIndicator - tooltip to leave open
     */
    var closeOtherTooltips = function (tooltipIndicator) {
        var tooltipArray = $("." + TOOLTIP_INDICATOR_CLASS);
        _.each(tooltipArray, function (tooltip) {
            if (tooltipIndicator !== tooltip) {
                closeTooltip(tooltip);
            }
        });
    };

    /**
     * Closes the tooltip by hiding it.
     * @param tooltipIndicator - tooltip to close
     */
    var closeTooltip = function (tooltipIndicator) {
        if (isTooltipOpen(tooltipIndicator)) {
            hideTooltip(tooltipIndicator);
            $(tooltipIndicator).removeClass(TOOLTIP_ARROW_UP + " " + TOOLTIP_ARROW_DOWN);
            $('body').off(EVENT_NAMESPACE);
        }
    };

    /**
     * Will add the close button
     * @param tooltipIndicator
     */
    var addCloseButton = function (tooltipIndicator) {
        var tooltipContainer = getTooltipContainer(tooltipIndicator);
        var $tooltipContainer = $(tooltipContainer);
        var closeBtn = document.createElement('div');
        var $closeBtn = $(closeBtn);
        $closeBtn.addClass(TOOLTIP_HEADER);
        var closeLabel = ko.i18n.renderString('tooltip.close.button');
        $closeBtn.html('<button class="tooltip-close-button close ns-btn-close"><i class="fa fa-fw fa-times-circle"></i> <span class="sr-only">' + closeLabel + '</span></button>');
        $tooltipContainer.prepend($closeBtn);
    };

    /**
     * Displays the tooltip when invoked. Gets triggered by user hovering or clicking on the tooltip Indicator.
     * @param tooltipIndicator - tooltip indicator where the event originated from
     * @param option - the options that were set in initializeTooltip
     */
    var openTooltip = function (tooltipIndicator, option) {
        if (option.onlyIf !== undefined && !ko.unwrap(option.onlyIf)) {
            return;
        }

        var truncated = tooltipIndicator.scrollWidth > tooltipIndicator.clientWidth;

        // dont show the tooltip when text isn't truncated
        // and the associated element is configured not to
        // show tooltips when no truncation has occurred
        if (option.displayOnTruncateOnly && !truncated) { return; }

        if (!isTooltipOpen(tooltipIndicator)) {
            //Get options
            var placement   = option.placement;
            var selfDismiss = option.selfDismiss;

            closeOtherTooltips(tooltipIndicator);
            clearTooltipOpenTimeout(tooltipIndicator);

            var _showTooltip = function (nodes) {
                var tooltipContainer;
                if (nodes) {
                    var node = nodes[0];
                    tooltipContainer = node.parentNode.parentNode;
                    ko.utils.domData.set(tooltipIndicator, TT_CONTAINER_NAME, tooltipContainer);
                    if (!selfDismiss) {
                        addCloseButton(tooltipIndicator);
                    }
                }

                //Position Tooltip
                positionTooltip(tooltipIndicator, placement);

                //show tooltip and setup Events
                tooltipContainer = showTooltip(tooltipIndicator);

                _.defer(function () {
                    $('body').on('click' + EVENT_NAMESPACE, {tooltipIndicator: tooltipIndicator, tooltipContainer: tooltipContainer},  HandleCloseTooltipFromDocument);
                    $(window).one('resize' + EVENT_NAMESPACE, {tooltipIndicator: tooltipIndicator, tooltipContainer: tooltipContainer},  HandleCloseTooltipFromDocument);
                    $(window).one('scroll' + EVENT_NAMESPACE, {tooltipIndicator: tooltipIndicator, tooltipContainer: tooltipContainer},  HandleCloseTooltipFromDocument);
                    $(tooltipIndicator).parents().one('scroll' + EVENT_NAMESPACE, {tooltipIndicator: tooltipIndicator, tooltipContainer: tooltipContainer},  HandleCloseTooltipFromDocument);
                    if (selfDismiss) {
                        $(tooltipIndicator).one('mouseleave' + EVENT_NAMESPACE, {tooltipIndicator: tooltipIndicator, tooltipContainer: tooltipContainer},  HandleCloseTooltipFromDocument);
                    } else {
                        $("." + TOOLTIP_CLOSE_BUTTON, tooltipContainer).one('click' + EVENT_NAMESPACE, {tooltipIndicator: tooltipIndicator, tooltipContainer: tooltipContainer},  HandleCloseTooltipFromDocument);
                    }
                });
            };

            createTooltip(tooltipIndicator, option,_showTooltip);
        }
    };

    /**
     * Creates a tooltip and renders it for the first time.
     * @param tooltipIndicator
     * @param option
     * @param afterRender - typically _showTooltip
     */
    var createTooltip = function (tooltipIndicator, option, afterRender) {
        var content         = option.content;
        var template        = option.template;
        var bindingArgs     = option.options;
        var cssClass        = (option.cssClass) ? option.cssClass : "";
        var data            = option.viewModel;
        var text            = option.text;
        var html            = option.html;
        var valueAccessor   = ko.unwrap(bindingArgs[1]);
        var tooltipId       = $(tooltipIndicator).attr('tooltip_id');
        var $prevContainer  = $("#" + tooltipId);

        // prevents previous calls to create the same tooltip from building up tooltips that cannot be removed.
        if ($prevContainer.length) {
            $prevContainer.remove();
        }

        //Create tooltip Container
        var tooltipContainer    = document.createElement('div');
        var $tooltipContainer   = $(tooltipContainer);
        $tooltipContainer.addClass(TOOLTIP_CONTAINER_CLASS + " " + cssClass);
        $tooltipContainer.attr('role', 'tooltip');
        $tooltipContainer.attr('id', tooltipId);

        $('body').append(tooltipContainer);

        // Setting this now so that the dom disposal has a chance to remove it if the
        // indicator is removed before the tolltip is rendered
        ko.utils.domData.set(tooltipIndicator, TT_CONTAINER_NAME, tooltipContainer);

        //Create tooltip inner
        var tooltipInnerDiv = document.createElement('div');
        $(tooltipInnerDiv).addClass(TOOLTIP_INNER_CLASS);
        $tooltipContainer.append(tooltipInnerDiv);

        //Create tooltip tail
        //Add tooltipTail
        var tailDiv = document.createElement('div');
        $(tailDiv).addClass(TOOLTIP_TAIL_CLASS);
        $tooltipContainer.append(tailDiv);

        //Now let's get the content of the tooltip
        if (content) {
            renderlStringInTooltip(tooltipInnerDiv, content, valueAccessor, bindingArgs, afterRender);
        } else if (template) {
            renderTemplateInTooltip(tooltipInnerDiv, template, data, afterRender);
        } else if(text) {
            renderTextInTooltip(tooltipInnerDiv, text, afterRender);
        } else if (html) {
            renderHtmlInTooltip(tooltipInnerDiv, html, afterRender);
        }
    };

    /**
     * Delegates to the lString Binding to render in the tooltip
     * @param tooltipDiv
     * @param content
     * @param valueAccessor
     * @param afterRender
     */
    var renderlStringInTooltip = function (tooltipDiv, content, valueAccessor, bindingArgs, afterRender) {
        $(tooltipDiv).html(content);
        var messageKey = (typeof valueAccessor === 'function') ? valueAccessor().messageKey : valueAccessor.messageKey;
        valueAccessor = function () {
            return {
                'data': {},
                'name': messageKey
            };
        };
        var allBindingsAccessor = bindingArgs[2];
        var viewModel = bindingArgs[3];
        ko.bindingHandlers.lString.update(tooltipDiv.firstChild, valueAccessor, allBindingsAccessor, viewModel);
        afterRender($(tooltipDiv.firstChild)); //passing in child of tooltip container
    };

    /**
     * Renders template inside of the tooltip
     * @param tooltipDiv - tooltip container node
     * @param template - String for  template location and name
     * @param data - viewModel Object
     * @param afterRender - callback function after rendering the template
     */
    var renderTemplateInTooltip = function (tooltipDiv, template, data, afterRender) {
        var templateName = template;
        include.loadTemplate(templateName).then(function () {
            ko.renderTemplate(templateName, data, {afterRender: afterRender}, tooltipDiv, "replaceChildren");
        });
    };

    /**
     * Renders non localized text in the tooltip
     * @param tooltipDiv - tooltip container node
     * @param text - String to be rendered
     * @param afterRender - callback function
     */

    var renderTextInTooltip = function (tooltipDiv, text, afterRender) {
        // text instead of html to avoid script injection
        $(tooltipDiv).text(text);
        afterRender($(tooltipDiv.firstChild));
    };

    /**
     * Renders html in the tooltip
     * @param tooltipDiv - tooltip container node
     * @param html - HTML to be rendered
     * @param afterRender - callback function
     */
    var renderHtmlInTooltip = function (tooltipDiv, html, afterRender) {
        $(tooltipDiv).html(html);
        afterRender($(tooltipDiv.firstChild));
    };

    /**
     * Cleanup method for when the element's DOM is removed.
     */
    var onDisposal = function (element) {
        // clean up events
        cleanupNodeEvent($(element));
        clearTooltipOpenTimeout(element);
        //remove tooltip containers from body
        var tooltipContainer = getTooltipContainer(element);
        if (tooltipContainer) {
            $(tooltipContainer).remove();
        }
    };

    var cleanupNodeEvent = function ($element) {
        $element.off(EVENT_NAMESPACE);
    };

    /**
     * Gets the size of padding-left and border-left for the tooltipIndicator
     * @param $tooltipIndicator
     * @returns {*} - integer - Sum of padding Left and Border Left of the tooltipIndicator
     */
    var getIndicatorLeftWhiteSpace = function ($tooltipIndicator) {
        var paddingLeft =  parseInt($tooltipIndicator.css('padding-left'),10);
        paddingLeft = isNaN(paddingLeft) ? 0 : paddingLeft;

        var borderLeft  =  parseInt($tooltipIndicator.css('border-left'),10);
        borderLeft  = isNaN(borderLeft) ? 0 : borderLeft;

        return paddingLeft + borderLeft;
    };

    /***
     * This function will position the tooltip near the tooltip indicator
     * It detects the best placement for the tooltip container unless specified by the user
     * @param tooltipIndicator - node for the tooltip indicator
     * @param location - String indicating where to place the tooltip
     */
    var positionTooltip = function (tooltipIndicator, location) {

        var $tooltipIndicator = $(tooltipIndicator);
        var $tooltipContainer = $(getTooltipContainer(tooltipIndicator));

        var tooltipIndicatorOffSet = $tooltipIndicator.offset();
        var $parentContainer = $(window);

        var spaceTop = tooltipIndicatorOffSet.top;
        var tooltipIndicatorPaddingBorderSpace = getIndicatorLeftWhiteSpace($tooltipIndicator);
        var spaceLeft = tooltipIndicatorOffSet.left + tooltipIndicatorPaddingBorderSpace;

        var spaceAroundTTIndicator = {
            'top'   : spaceTop + ($tooltipIndicator.outerHeight() / 2),  //Space on top of indicator from middle of the indicator up of parent container
            'left'  : spaceLeft + (($tooltipIndicator.outerWidth() - tooltipIndicatorPaddingBorderSpace)/2), //Space to the left of indicator from middle of the indicator to the left border of parent container
            'right' : $parentContainer.outerWidth() - spaceLeft //Space to the bottom of the indicator from center of indicator to the bottom of window
        };

        var placement = (location) ? getUserPlacement(location) : getAutoPlacement(spaceAroundTTIndicator, $tooltipContainer);

        if (placement[0] === "top" && placement[1] === "left") {
            positionTopLeft($tooltipContainer, $tooltipIndicator, spaceTop, spaceAroundTTIndicator);
        } else if (placement[0] === "top" && placement[1] === "right") {
            positionTopRight($tooltipContainer, $tooltipIndicator, spaceTop, spaceAroundTTIndicator);
        }

        if (placement[0] === "bottom" && placement[1] === "left") {
            positionBottomLeft($tooltipContainer, $tooltipIndicator, spaceTop, spaceAroundTTIndicator);
        } else if (placement[0] === "bottom" && placement[1] === "right") {
            positionBottomRight($tooltipContainer, $tooltipIndicator, spaceTop, spaceAroundTTIndicator);
        }
    };

    /**
     * Positions the tooltip to the top right of the tooltip indicator
     * @param $tooltipContainer
     * @param $tooltipIndicator
     * @param spaceTop
     * @param spaceAroundTTIndicator
     */
    var positionTopLeft= function ($tooltipContainer, $tooltipIndicator, spaceTop, spaceAroundTTIndicator) {

        //Update tooltip tail classes to reflect which way to point
        var $tail = cleanTooltipTailClass($tooltipContainer);
        $tail.addClass(TOOLTIP_ARROW_DOWN);
        var tailMargin = parseInt($tail.css('margin-right'), null);
        var tailBorder = parseInt($tail.css('border-left-width'), null);

        //Get new top position
        var tooltipContainerOuterHeight = $tooltipContainer.outerHeight();
        var tooltipContainerOuterWidth  = $tooltipContainer.outerWidth();
        var tooltipContainerPadding     = parseInt($tooltipContainer.css('padding-right'), null);
        var newTopPosition              = spaceTop - (tooltipContainerOuterHeight) - $(window).scrollTop();

        //Get new left position
        var newLeftPosition = spaceAroundTTIndicator.left - $tooltipContainer.outerWidth(); // Flush right border of tooltipContainer to center of tooltipIndicator

        //Move tooltipContainer to vertically align the center of the tooltipTail to center of tooltipIndicator
        newLeftPosition += tooltipContainerPadding + tailMargin + tailBorder;
        $tooltipContainer.css({'top': newTopPosition,'left': newLeftPosition,'height': tooltipContainerOuterHeight, 'min-width': tooltipContainerOuterWidth});

        //Now move tail to proper vertical position
        var tailAdjust = -tooltipContainerPadding;
        $tail.css('bottom', tailAdjust);

        //Move tail to proper horizontal position
        $tail.addClass(TOOLTIP_TAIL_RIGHT_POS);
    };

    /**
     * Positions the tooltip to the top right of the tooltip indicator
     * @param $tooltipContainer
     * @param $tooltipIndicator
     * @param spaceTop
     * @param spaceAroundTTIndicator
     */
    var positionTopRight= function ($tooltipContainer, $tooltipIndicator, spaceTop, spaceAroundTTIndicator) {

        //Update tooltip tail classes to reflect which way to point
        var $tail = cleanTooltipTailClass($tooltipContainer);
        $tail.addClass(TOOLTIP_ARROW_DOWN);
        var tailMargin = parseInt($tail.css('margin-right'), null);
        var tailBorder = parseInt($tail.css('border-left-width'), null);

        //Get new top position
        var tooltipContainerOuterHeight = $tooltipContainer.outerHeight();
        var tooltipContainerOuterWidth  = $tooltipContainer.outerWidth();
        var tooltipContainerPadding     = parseInt($tooltipContainer.css('padding-right'), null);
        var newTopPosition = spaceTop - (tooltipContainerOuterHeight) - $(window).scrollTop();

        //Get new left position
        var  newLeftPosition = spaceAroundTTIndicator.left;   //Flush left border to middle of tooltipIndicator

        //Move tooltipContainer to vertically align the center of the tooltipTail to center of tooltipIndicator
        newLeftPosition -= tooltipContainerPadding + tailMargin + tailBorder;
        $tooltipContainer.css({'top': newTopPosition,'left': newLeftPosition,'height': tooltipContainerOuterHeight, 'min-width': tooltipContainerOuterWidth});

        //Now move tail to proper vertical position
        var tailAdjust = -tooltipContainerPadding;
        $tail.css('bottom', tailAdjust);

        //Move tail to proper horizontal position
        $tail.addClass(TOOLTIP_TAIL_LEFT_POS);
    };

    /**
     * Positions the tooltip to the bottom left of the tooltip indicator
     * @param $tooltipContainer
     * @param $tooltipIndicator
     * @param spaceTop
     * @param spaceAroundTTIndicator
     */
    var positionBottomLeft = function ($tooltipContainer, $tooltipIndicator, spaceTop, spaceAroundTTIndicator) {

        //Update tooltip tail classes to reflect which way to point
        var $tail = cleanTooltipTailClass($tooltipContainer);
        $tail.addClass(TOOLTIP_ARROW_UP);
        var tailMargin = parseInt($tail.css('margin-right'), null);
        var tailBorder = parseInt($tail.css('border-left-width'), null);

        //Get new top position
        var newTopPosition              = spaceTop + $tooltipIndicator.outerHeight() + getTailHeight() - $(window).scrollTop();
        var tooltipContainerOuterHeight = $tooltipContainer.outerHeight();
        var tooltipContainerOuterWidth  = $tooltipContainer.outerWidth();
        var tooltipContainerPadding     = parseInt($tooltipContainer.css('padding-right'), null);

        //Get new left position
        var newLeftPosition = spaceAroundTTIndicator.left - $tooltipContainer.outerWidth(); //Flush right border of tooltipContainer to center of tooltipIndicator

        //Move tooltipContainer to vertically align the center of the tooltipTail to center of tooltipIndicator
        newLeftPosition += tooltipContainerPadding + tailMargin + tailBorder;
        
        // Adjust the tooltip left position when the tooltip overflows to the right of the screen
        if(newLeftPosition + tooltipContainerOuterWidth > $(window).width()) {
            newLeftPosition = $(window).width() - tooltipContainerOuterWidth - 1;
        }
        $tooltipContainer.css({'top': newTopPosition,'left': newLeftPosition,'height': tooltipContainerOuterHeight, 'min-width': tooltipContainerOuterWidth});

        //Move tail to proper vertical position
        var tailAdjust = tooltipContainerOuterHeight - 1;
        $tail.css('bottom', tailAdjust);

        //Move tail to proper horizontal position
        $tail.addClass(TOOLTIP_TAIL_RIGHT_POS);
    };

    /**
     * Positions the tooltip to the bottom right of the tooltip indicator
     * @param $tooltipContainer
     * @param $tooltipIndicator
     * @param spaceTop
     * @param spaceAroundTTIndicator
     */
    var positionBottomRight = function ($tooltipContainer, $tooltipIndicator, spaceTop, spaceAroundTTIndicator) {

        //Update tooltip tail classes to reflect which way to point
        var $tail = cleanTooltipTailClass($tooltipContainer);
        $tail.addClass(TOOLTIP_ARROW_UP);
        var tailMargin = parseInt($tail.css('margin-right'), null);
        var tailBorder = parseInt($tail.css('border-left-width'), null);

        //Get new top position
        var newTopPosition              = spaceTop + $tooltipIndicator.outerHeight() + getTailHeight() - $(window).scrollTop();
        var tooltipContainerOuterHeight = $tooltipContainer.outerHeight();
        var tooltipContainerOuterWidth  = $tooltipContainer.outerWidth();
        var tooltipContainerPadding     = parseInt($tooltipContainer.css('padding-right'), null);

        //Get new left position
        var  newLeftPosition =  spaceAroundTTIndicator.left; //Flush left border to middle of tooltipIndicator

        //Move tooltipContainer to vertically align the center of the tooltipTail to center of tooltipIndicator
        newLeftPosition -= tooltipContainerPadding + tailMargin + tailBorder;
        $tooltipContainer.css({'top': newTopPosition,'left': newLeftPosition,'height': tooltipContainerOuterHeight, 'min-width': tooltipContainerOuterWidth});

        //Move tail to proper vertical position
        var tailAdjust = tooltipContainerOuterHeight - 1;
        $tail.css('bottom', tailAdjust);

        //Move tail to proper horizontal position
        $tail.addClass(TOOLTIP_TAIL_LEFT_POS);
    };

    /**
     * returns the height of the tooltip tail
     */
    var getTailHeight = function () {
        return parseInt($("." + TOOLTIP_TAIL_CLASS).css("border-left-width"), null);
    };

    /**
     * Removes unwanted classed from the tooltip tail and returns the tooltip tail element under the tooltipContainer
     * @param $tooltipContainer
     * @returns {*|HTMLElement}
     */
    var cleanTooltipTailClass = function ($tooltipContainer) {
        var $tooltipTail = $("." + TOOLTIP_TAIL_CLASS,$tooltipContainer[0]);
        $tooltipTail.removeClass(TOOLTIP_ARROW_UP + " " + TOOLTIP_ARROW_DOWN + " " + TOOLTIP_TAIL_RIGHT_POS + " " + TOOLTIP_TAIL_LEFT_POS);
        return $tooltipTail;
    };

    /**
     * Determines placement of tooltip (topleft topright bottomleft bottomright)
     * @param space is object containing measurement around the tooltip indicator {left:xxx, top:xxx, top:xxx, bottom:xxx}
     * @param $tooltipContainer
     * @returns {Array} will return array with first entry as horizontal positioning (top / bottom) and second entry with vertical positioning  (left / right)
     */
    var getAutoPlacement = function (spaceAroundTTIndicator, $tooltipContainer) {
        var placement = [];
        placement.push(spaceAroundTTIndicator.top > $tooltipContainer.outerHeight() + getTailHeight() ? "top" : "bottom");
        placement.push(spaceAroundTTIndicator.right > $tooltipContainer.outerWidth() ? "right" : "left");   //UX wants priority to the right
        return placement;
    };

    /**
     * Gets user placement
     * @param placement
     */
    var getUserPlacement = function (placement) {
        var result = [];
        if (placement.indexOf('top') >= 0) {
            result.push("top");
        } else if (placement.indexOf('bottom') >= 0) {
            result.push("bottom");
        }

        if (placement.indexOf('left') >= 0) {
            result.push("left");
        } else if (placement.indexOf('right') >= 0) {
            result.push("right");
        }
        return result;
    };


    var initializeTooltip = function ($element, valueAccessor, componentContext) {
        var options;
        var tooltipID = 'tooltip_' + tooltip_counter++;

        $element.attr('tooltip_id', tooltipID);
        $element.addClass(TOOLTIP_INDICATOR_CLASS);

        if (typeof valueAccessor === "string") {
            options = {
              text: valueAccessor,
              placement: null,
              options: arguments,
              cssClass: null,
              selfDismiss: SELF_DISMISS_DEFAULT,
              ignoreClick: IGNORE_CLICK,
              displayOnTruncateOnly: DISPLAY_ON_TRUNCATE_ONLY_DEFAULT
            };
        } else{

            var messageKey      = valueAccessor.messageKey;
            var template        = valueAccessor.template;
            var cssClass        = valueAccessor.cssClass;
            var selfDismiss     = (_.hasValue(valueAccessor.selfDismiss)) ? valueAccessor.selfDismiss : SELF_DISMISS_DEFAULT;
            var ignoreClick     = (_.hasValue(valueAccessor.ignoreClick)) ? valueAccessor.ignoreClick : IGNORE_CLICK;
            var displayOnTruncateOnly = (_.hasValue(valueAccessor.displayOnTruncateOnly)) ? valueAccessor.displayOnTruncateOnly : DISPLAY_ON_TRUNCATE_ONLY_DEFAULT;
            var data            = valueAccessor.data;
            var placement       = valueAccessor.placement;
            var text            = ko.unwrap(valueAccessor.text);
            var html            = ko.unwrap(valueAccessor.html);
            var onlyIf          = valueAccessor.onlyIf;
            var content;

            // Pull in the styling from the loading component (So they don't have to wrap the tooltip content with <div class="myComponent-component></div>)
            if (componentContext) {
                cssClass += (' ' + componentContext + COMPONENT_SUFFIX);
            }

            if (typeof messageKey === "string") {
                var bindString ="data-bind=\"" + LSTRING + ":'" + messageKey + "'\"";
                content = "<div " + bindString + "></div>";
                options = {content:content,  placement: placement, options: arguments, cssClass: cssClass, selfDismiss: selfDismiss, ignoreClick: ignoreClick, displayOnTruncateOnly: displayOnTruncateOnly};
            } else if (template) {
                options = {template: template, viewModel: data,  placement: placement, options: arguments, cssClass: cssClass, selfDismiss: selfDismiss, ignoreClick: ignoreClick, displayOnTruncateOnly: displayOnTruncateOnly};
            } else if (text) {
                options = {text: text,  placement: placement,  options: arguments, cssClass: cssClass, selfDismiss: selfDismiss, ignoreClick: ignoreClick, displayOnTruncateOnly: displayOnTruncateOnly, onlyIf: onlyIf};
            } else if (html) {
                options = {html: html,  placement: placement,  options: arguments, cssClass: cssClass, selfDismiss: selfDismiss, ignoreClick: ignoreClick, displayOnTruncateOnly: displayOnTruncateOnly};
            }
        }

        //Set Events
        if (options) {
            if (!options.ignoreClick) {
                $element.on('click' + EVENT_NAMESPACE, options, handleClickOnTTIndicator);
            }
            $element.on('mouseover' + EVENT_NAMESPACE, options, delayOpenTooltip);
        }
    };

    /**
     *  <p>Tooltip Binding Handler</p>
     *
     *  This binding will create a tooltip on the binding element.
     *  Example of binding syntax and properties:
     *
     *  1) data-bind = "tooltip: {text: 'This is tooltip content'}  - short hand: data-bind = "tooltip:'This is tooltip content'"
     *     Where text contains the non localized string that is displayed in the tooltip
     *
     *  OR
     *
     *  2) data-bind = "tooltip: {messageKey:'config.error.400', data:$data}" token replacement is done against data object
     *     Where messageKey is used as in the lString data-bind. Tooltip content is thus defined in the json local file ex: en-US.json
     *     and data is the viewModel object that will bind to the template. data is optional and may be omitted
     *
     *  OR
     *
     *  3) data-bind = "tooltip: {template: 'templates/help/sampleTooltipHelp', data:$data}"
     *     Where template is the name of the template to include in the tooltip
     *     and data is the viewModel object that will bind to the template. data is optional and may be omitted
     *
     *  With any of the example above you can also specify the following optional properties
     *
     *      placement: top,left / top,right / bottom,left / bottom, right
     *        for example:  data-bind = "tooltip: {text: "This is tooltip content", placement:"top,left"}
     *
     *      cssClass:  "class1 class2 class3"   These css classes will be added to the tooltip container
     *
     *      ignoreClick: true - will ignore tooltip click actions when user clicks the element (default is false - process click normally)
     *
     *      selfDismiss: true  - will default to true  - Self-dismisses the tooltip on mouseleave from the tooltip indicator
     *          for example: data-bind = "tooltip: {text: "This is tooltip content", selfDismiss: "true"}
     *
     *
     */
    ko.bindingHandlers.tooltip = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var value =  ko.unwrap(valueAccessor());
            if (value) {
                var $element = $(element);

                if (value.template) {
                    value.template = bindingHandlerUtils.adjustTemplateNameForContext(value.template, bindingContext);
                }
                var componentContext = bindingHandlerUtils.getContext(bindingContext);

                initializeTooltip ($element, value, componentContext);

                // Clean up the binding handler when the element is removed from the DOM.
                ko.utils.domNodeDisposal.addDisposeCallback(element, onDisposal.bind(null, element));
            }
        },

        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var value = ko.unwrap(valueAccessor());
            if (value) {
                if (value.template) {
                    value.template = bindingHandlerUtils.adjustTemplateNameForContext(value.template, bindingContext);
                }
                var componentContext = bindingHandlerUtils.getContext(bindingContext);

                var $element = $(element);
                var tooltipContainer = getTooltipContainer(element);
                if (tooltipContainer) {
                    $(tooltipContainer).remove();
                    ko.utils.domData.set(element, TT_CONTAINER_NAME, null);
                }
                cleanupNodeEvent($element);
                initializeTooltip($element, value, componentContext);
            }
        }
    };
});

